import React from "react";
import { Wrapper } from "../../shared/Wrapper";
import { Textarea } from "../../../../../../shared/Textarea/Textarea";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";

/**
 * @para {{
 *  question: string;
 *  description?: string;
 *  required?: boolean;
 *  value: string;
 *  onChange: (value: string) => void;
 * }} param0
 */
export function QuestionText({
  question,
  description,
  required,
  value,
  onChange,
}) {
  var { tSurvey: t } = useAppTranslation.Survey();

  return (
    <Wrapper title={question} description={description} required={required}>
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("text_paceholder")}
      />
    </Wrapper>
  );
}
